module.exports = __webpack_public_path__ + "static/img/liBgImage2-hover.c5e98bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/productCenter/subnav1/tab1/liBgImage2-hover.png
// module id = /U69
// module chunks = 0